import Login from './login';
Login.install = (app) => {
    app.component(Login.name, Login);
    app.component(Login.Socialite.name, Login.Socialite);
    return app;
};
export default Login;
